// extracted by mini-css-extract-plugin
module.exports = {"icon":"ProfilePlanStatus_icon__1tkJV"};